import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { isDemoUser } from '../lib/demo'

export default function DemoBanner() {
  const { profile } = useAuth()
  const navigate = useNavigate()

  if (!isDemoUser(profile?.email)) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 44,
        zIndex: 9999,
        background: 'linear-gradient(135deg, #0F4C81 0%, #1a365d 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: '0 16px',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13, fontWeight: 500 }}>
        You&apos;re exploring <strong>Northstar Hockey Academy</strong> &mdash; a live demo
      </span>
      <button
        onClick={() => window.dispatchEvent(new CustomEvent('startDemoTour'))}
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: '#fff',
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.25)',
          padding: '4px 14px',
          borderRadius: 6,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Take a Tour
      </button>
      <button
        onClick={() => navigate('/customer/dashboard')}
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: '#fff',
          background: 'rgba(255,255,255,0.15)',
          border: '1px solid rgba(255,255,255,0.4)',
          padding: '4px 14px',
          borderRadius: 6,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        See Client View &rarr;
      </button>
      <a
        href="https://aifacilitymanager.com/#trial"
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: '#000',
          background: '#00f2ff',
          padding: '4px 14px',
          borderRadius: 6,
          textDecoration: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        Start Your Free Trial &rarr;
      </a>
    </div>
  )
}
